export const ORCA_ON_CHAIN_FETCH_BEGIN = "ORCA_ON_CHAIN_FETCH_BEGIN";
export const ORCA_ON_CHAIN_FETCH_SUCCESS = "ORCA_ON_CHAIN_FETCH_SUCCESS";
export const ORCA_ON_CHAIN_FETCH_FAILURE = "ORCA_ON_CHAIN_FETCH_FAILURE";
